import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { BaseFeatureState } from './base-feature-state';
import { IPcAiService } from '@src/slide/application/service/ai/core/pc/pc-ai-service.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export default class BaseTitleBarFeature extends BaseFeatureState {
    public getSelectionService(): ISelectionService {
        return this.getAppServices().viewableServiceLayer.selectionService;
    }

    public getUiDataService(): IUiDataService {
        return this.getAppServices().getUiDataService();
    }

    public getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IPcEditorAppServices;
    }

    public getMenuManager(): IMenuManager | undefined {
        return this.getAppServices().editableServiceLayer?.menuManager;
    }

    public getAiService(): IDynamicService<IPcAiService> | undefined {
        return this.getAppServices().editableServiceLayer?.aiService;
    }
}
